import React, { useState } from "react";
import { Modal } from "react-bootstrap"; // Utilizando o modal do Bootstrap
import "./../styles/InfiniteCarousel.css";

// Importando as imagens diretamente
import img2 from "../assets/img/empresasClientes/image2.png";
import img3 from "../assets/img/empresasClientes/image3.png";
import img4 from "../assets/img/empresasClientes/image4.png";
import img5 from "../assets/img/empresasClientes/image5.png";
import img6 from "../assets/img/empresasClientes/image6.png";
import img7 from "../assets/img/empresasClientes/image7.png";
import img8 from "../assets/img/empresasClientes/image8.png";
import img11 from "../assets/img/empresasClientes/image11.png";
import img12 from "../assets/img/empresasClientes/image12.png";
import img14 from "../assets/img/empresasClientes/image14.png";
import img15 from "../assets/img/empresasClientes/image15.png";
import img16 from "../assets/img/empresasClientes/image16.png";
import img18 from "../assets/img/empresasClientes/image18.png";
import img19 from "../assets/img/empresasClientes/image19.png";
import img20 from "../assets/img/empresasClientes/image20.png";
import img21 from "../assets/img/empresasClientes/image21.png";
import img22 from "../assets/img/empresasClientes/image22.png";
import img23 from "../assets/img/empresasClientes/image23.png";
import img27 from "../assets/img/empresasClientes/image27.jpg";
import img28 from "../assets/img/empresasClientes/image28.png";
import img29 from "../assets/img/empresasClientes/image29.png";
import img30 from "../assets/img/empresasClientes/image30.jpg"; // Adicionei uma imagem extra para completar o exemplo
import img31 from "../assets/img/empresasClientes/image31.jpg"; // Adicionei uma imagem extra para completar o exemplo



const InfiniteCarousel = () => {
  // Estado para controlar o modal
  const [modalShow, setModalShow] = useState(false);
  const [selectedLogo, setSelectedLogo] = useState<string | null>(null);

  // Função para abrir o modal e mostrar o logo clicado
  const handleLogoClick = (logoSrc: string) => {
    setSelectedLogo(logoSrc);
    setModalShow(true);
  };

  const logos = [
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img11,
    img12,
    img14,
    img15,
    img16,
    img18,
    img19,
    img20,
    img21,
    img22,
    img23,
    img27,
    img28,
    img29,
    img30, // Adicionei uma imagem extra para completar o exemplo
    img31, // Adicionei uma imagem extra para completar o exemplo
  ];

  // Criando um efeito infinito duplicando a lista de imagens
  const infiniteLogos = [...logos, ...logos];

  return (
    <div className="container mt-4">
      <h1 className="title" data-aos="fade-up">
        Nossos Clientes
      </h1>
      <div className="logos">
        <div className="logos-slide">
          {infiniteLogos.map((logoSrc, index) => (
            <img
              key={index}
              src={logoSrc}
              alt={`Logo ${index}`}
              data-aos="fade-right"
              onClick={() => handleLogoClick(logoSrc)}
              className="logo-item"
            />
          ))}
        </div>
        <div className="logos-slide">
          {infiniteLogos.map((logoSrc, index) => (
            <img
              key={index}
              src={logoSrc}
              data-aos="fade-left"
              alt={`Logo ${index}`}
              onClick={() => handleLogoClick(logoSrc)}
              className="logo-item"
            />
          ))}
        </div>
      </div>

      {/* Modal */}
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Informações do Cliente</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img
            src={selectedLogo || ""}
            alt="Logo Selecionado"
            className="modal-logo"
          />
          <p>Detalhes do cliente aqui...</p>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default InfiniteCarousel;
